import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "新奥集团"
    }
  },
  {
    path: "/topper",
    name: "Topper",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Topper.vue")
  },
  {
    path: "/footer",
    name: "Footer",
    component: () => import("../views/Footer.vue"),
    meta: {
      title: "底部"
    }
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../views/About.vue"),
    meta: {
      title: "关于新奥"
    }
  },
  {
    path: "/news",
    name: "news",
    component: () => import("../views/News.vue"),
    meta: {
      title: "新奥动态"
    }
  },
  {
    path: "/energy",
    name: "energy",
    component: () => import("../views/Energy.vue"),
    meta: {
      title: "清洁能源"
    }
  },
  {
    path: "/intelligent",
    name: "intelligent",
    component: () => import("../views/Intelligent.vue"),
    meta: {
      title: "产业智能"
    }
  },
  {
    path: "/innovate",
    name: "innovate",
    component: () => import("../views/Innovate.vue"),
    meta: {
      title: "创新能力"
    }
  },
  {
    path: "/talent",
    name: "talent",
    component: () => import("../views/Talent.vue"),
    meta: {
      title: "人才激发"
    }
  },
  {
    path: "/life",
    name: "life",
    component: () => import("../views/Life.vue"),
    meta: {
      title: "品质生活"
    }
  },
  {
    path: "/contactus",
    name: "contactus",
    component: () => import("../views/Contactus.vue"),
    meta: {
      title: "联系我们"
    }
  },
  {
    path: "/legal",
    name: "legal",
    component: () => import("../views/Legal.vue"),
    meta: {
      title: "法律声明"
    }
  },
  {
    path: "/news_20240430",
    name: "news_20240430",
    component: () => import("../views/news_20240430.vue"),
    meta: {
      title: "新奥动态"
    }
  },
  {
    path: "/news_20240101",
    name: "news_20240101",
    component: () => import("../views/news_20240101.vue"),
    meta: {
      title: "新奥动态"
    }
  },
  {
    path: "/newsDetail",
    name: "newsDetail",
    component: () => import("../views/newsDetail.vue"),
    meta: {
      title: "新奥动态"
    }
  },
  {
    path: "/En_home",
    name: "En_home",
    component: () => import("../views/En_home.vue"),
    meta: {
      title: "ENN Group"
    }
  },
  {
    path: "/En_about",
    name: "En_about",
    component: () => import("../views/En_about.vue"),
    meta: {
      title: "About ENN"
    }
  },
  {
    path: "/En_contactus",
    name: "En_contactus",
    component: () => import("../views/En_contactus.vue"),
    meta: {
      title: "Contact Us"
    }
  },
  {
    path: "/En_energy",
    name: "En_energy",
    component: () => import("../views/En_energy.vue"),
    meta: {
      title: "Clean Energy"
    }
  },
  {
    path: "/En_topper",
    name: "En_topper",
    component: () => import("../views/En_topper.vue"),
    meta: {
      title: "En_topper"
    }
  },
  {
    path: "/En_footer",
    name: "En_footer",
    component: () => import("../views/En_footer.vue"),
    meta: {
      title: "En_footer"
    }
  },
  {
    path: "/En_innovate",
    name: "En_innovate",
    component: () => import("../views/En_innovate.vue"),
    meta: {
      title: "Innovation Capability"
    }
  },
  {
    path: "/En_intelligent",
    name: "En_intelligent",
    component: () => import("../views/En_intelligent.vue"),
    meta: {
      title: "Industrial Intelligence"
    }
  },
  {
    path: "/En_legal",
    name: "En_legal",
    component: () => import("../views/En_legal.vue"),
    meta: {
      title: "Legal Notice"
    }
  },
  {
    path: "/En_life",
    name: "En_life",
    component: () => import("../views/En_life.vue"),
    meta: {
      title: "Quality Life"
    }
  },
  {
    path: "/En_news_20240101",
    name: "En_news_20240101",
    component: () => import("../views/En_news_20240101.vue"),
    meta: {
      title: "ENN News"
    }
  },
  {
    path: "/En_news_20240430",
    name: "En_news_20240430",
    component: () => import("../views/En_news_20240430.vue"),
    meta: {
      title: "ENN News"
    }
  },
  {
    path: "/En_news",
    name: "En_news",
    component: () => import("../views/En_news.vue"),
    meta: {
      title: "ENN News"
    }
  },
  {
    path: "/En_newsdetail",
    name: "En_newsdetail",
    component: () => import("../views/En_newsdetail.vue"),
    meta: {
      title: "ENN News"
    }
  },
  {
    path: "/En_talent",
    name: "En_talent",
    component: () => import("../views/En_talent.vue"),
    meta: {
      title: "Talent Career"
    }
  }
];

const router = new VueRouter({
  routes
});

export default router;
